// extracted by mini-css-extract-plugin
export default {"container":"style_card_stack_container__zo62F","deck":"style_card_stack_deck__ayCuY"};